import React from 'react';

const FreeGiftContainer = ({ isMiniCart, isCheckout, campaignText }) => {
    return (
        <div className="free-gift">
            <div
                className={`free-gift__container ${isMiniCart ? ' no-shadow is-mini-cart' : ''} ${isCheckout ? ' checkout no-shadow' : ''}`}>
                <div className={`free-gift__text ${isMiniCart || isCheckout ? ' mini-cart-content' : ''}`}>
                    {campaignText ? campaignText : null}
                </div>
            </div>
        </div>
    );
};

export default FreeGiftContainer;
